import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Icon, Message } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { LoginAuth } from '../DashboardClasses';
import API from '../API';

interface LoginResponseProps{
	onLogin?: (auth: LoginAuth)=>void,
}

var LoginResponse = (props: LoginResponseProps)=>{
	var { t } = useTranslation();
	var [params] = useSearchParams();
	var [loadError, setLoadError] = useState<string>(null);
	var auth_params = useMemo(()=>{
		var token = params.get('a');
		var expiration = parseInt(params.get('e'));
		var redirect = params.get('r');
		if(!token || !expiration) return null;

		var now = moment().unix();
		if(expiration<now) return null;

		return { token, expiration, redirect };
	}, [params]);

	useEffect(()=>{
		if(!auth_params) return;
		API.verifyLogin(auth_params.token, auth_params.expiration).then(auth=>{
			if(!auth) return setLoadError(t('auth.invalid_login'));
			if(props.onLogin) props.onLogin(auth);
			window.location.href = decodeURI(auth_params.redirect);
		}).catch(err=>{
			return setLoadError(t('auth.unexpected_error', { code: 'VFYLG-1' }));
		});
	}, [auth_params]);

	
	return <div className='pf login-auth-screen'>
		{(auth_params && !loadError) ? (
			<Icon name='money-bill-wave' />
		) : <>
			<Icon name="frown-open" style={{ color: 'black', marginBottom: 10 }} />
			<Message centered>
				{loadError || t('auth.invalid_params')}
			</Message>
			<Button style={{ marginTop: 10 }} color='black' text={t('common.retry')} as={Link} to={API.getLoginUrl()} />
		</>}
	</div>
}

export default LoginResponse;